{
	"accounts": "Konton",
	"invitations": "Inbjudningar",
	"subscribeToFeedback": "Anmäl dig till feedbackprogrammet",
	"notificationSettings": {
		"title": "Inställningar för e-postnotifikationer",
		"invoicingInformation": "Faktureringsinformation",
		"declarationProcessingStatus": "Bearbetningsstatus för deklaration",
		"enabled": "På",
		"disabled": "Av",
		"toast": {
			"success": "Aviseringsinställningen har uppdaterats",
			"error": "Det gick inte att uppdatera aviseringsinställningen"
		}
	},
	"about": {
		"title": "Om",
		"termsAndConditions": "Allmänna villkor",
		"privacyPolicy": "Integritetspolicy",
		"imprint": "Juridisk information",
		"openSourceAttribution": "Open source-attribution"
	},
	"language": {
		"title": "Språk",
		"footer": "Språkändringar kommer att gälla för alla Heidelberg Materials-applikationer"
	},
	"impressum": "Juridisk information",
	"copyright": "© 2024 Heidelberg Materials. Alla rättigheter förbehållna.",
	"login": "Logga in",
	"logout": "Logga ut"
}
